<template>
  <section class="login-section d-flex justify-content-center align-items-center">
    <div class="login-card shadow-lg">

      <!-- Logo -->
      <div class="text-center mb-4">
        <img src="../../../assets/logoLogin/topas.png" width="100" height="100" alt="Logo" />
      </div>

      <!-- Usuario -->
      <div class="input-group mb-3">
        <span class="input-group-text bg-white">
          <i class="bi bi-person-fill text-secondary"></i>
        </span>
        <input type="text" class="form-control" placeholder="Usuario o DNI" v-model="user.usuCodigo" />
      </div>

      <!-- Contraseña -->
      <div class="input-group mb-4">
        <span class="input-group-text bg-white">
          <i class="bi bi-lock-fill text-secondary"></i>
        </span>
        <input type="password" class="form-control" placeholder="Contraseña" v-model="user.usuContrasena" />
      </div>

      <!-- Botón -->
      <button @click="login(user)" class="btn btn-success w-100 py-2 fw-bold">
        INGRESAR
      </button>


      <div class="text-center mt-3 border-top pt-3">
        <span class="text-white-50 small">
          ¿No cuentas con usuario?
        </span>
        <a class="text-white fw-semibold pointer ms-1" @click="$router.push('/registro')">
          Regístrate aquí
        </a>
      </div>
    </div>
  </section>
</template>


<script>
import { mapActions } from "vuex";
export default {
  name: "SolimanologLoginPostulante",

  data() {
    return {
      user: {
        usuCodigo: "",
        usuContrasena: "",
      },
    };
  },

  mounted() { },
  created() { },

  methods: {
    ...mapActions("auth", ["login"]),
  },
};
</script>
<style scoped>
.login-section {
  min-height: 100vh;
  width: 100%;
  background: url("../../../assets/postulante/logo.jpeg") no-repeat center;
  background-size: cover;
  position: relative;
}

.login-section::before {
  content: "";
  position: absolute;
  inset: 0;

}

.pointer {
  cursor: pointer;
  font-size: 0.75rem;
}

.login-card {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 360px;
  background-color: rgba(0, 44, 93, 0.93);
  border-radius: 14px;
  padding: 2rem;
}

.input-group-text {
  border-right: none;
}

.form-control {
  border-left: none;
}

.form-control:focus {
  box-shadow: none;
  border-color: #198754;
}

button {
  border-radius: 8px;
}
</style>
